module.exports = __webpack_public_path__ + "img/llp.80fe37aa.webp";